import React from 'react';
import MuiTreeItem, { TreeItemProps as MuiTreeItemProps } from '@material-ui/lab/TreeItem';
import { makeStyles } from 'design-system/styles';

const useStyles = makeStyles<Pick<TreeItemProps, 'indentation'>>(theme => ({
  group: {
    marginLeft: 11,
    paddingLeft: 15,
    borderLeft: props =>
      props.indentation ? `1px ${props.indentation} ${theme.colors.gray20}` : 'none',
  },
}));

export interface TreeItemProps extends MuiTreeItemProps {
  indentation?: 'solid' | 'dashed';
}

const TreeItem = ({ classes: classOverrides, indentation, ...props }: TreeItemProps) => {
  const classes = useStyles({ indentation });
  return <MuiTreeItem classes={{ ...classes, ...classOverrides }} {...props} />;
};

export default TreeItem;
